module.exports = __webpack_public_path__ + "img/T5-A-rc_16.7a3c3079.png";